import { render } from "./EmbedEventsView.vue?vue&type=template&id=02cb0344"
import script from "./EmbedEventsView.vue?vue&type=script&lang=js"
export * from "./EmbedEventsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__